import { FC } from "react";

import classes from "./Modal.module.scss";

interface ModalProps {
  closeModal?: () => void;
  width?: string;
  children: any;
}

const Modal: FC<ModalProps> = (props) => {
  const onClose = () => {
    props.closeModal && props.closeModal();
  };

  return (
    <div className={classes.modal} onMouseDown={onClose}>
      <div
        className={classes.content}
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
        style={{ width: `${props.width}` }}
      >
        <div className={classes.container}>{props.children}</div>
      </div>
    </div>
  );
};

export default Modal;
